import { useEffect, useState, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { fetchTopMatches } from 'stores/match/index.js';
import {
  fetchTopOutrights,
  selectTopOutrightEvents
} from 'stores/outrights';
import MatchCard from 'components/general/match_card.js';
import TournamentCard from 'views/outrights/components/TournamentCard';
import TitleHistoryBack from 'components/general/TitleHistoryBack.js';
import { Col, Row } from 'react-bootstrap';
import { eventsToGroup } from 'toolkit/eventsToGroup.js';
import { AWS_BUCKET_URL } from 'toolkit/constants';

export default function TopMatchesList() {
  const dispatch = useDispatch();
  const selectedLocale = useSelector((state) => state.match.selectedLocale);
  const locales = useSelector((state) => state.match.locales);
  const [selectedMarketType, setSelectedMarketType] = useState(1);
  const { t } = useTranslation('translations');
  const [sports, setSports] = useState({});
  const topOutrights = useSelector(selectTopOutrightEvents);
  const topMatchesEvents = useSelector(
    (state) => {
      const { topMatches, events } = state.match;
      return topMatches
        .map((c) => events[c])
        .filter((match) => {
          if (!match || !match.markets) return false;
          return (
            match.markets[0].outcomes[0]?.odds !== null ||
            match.markets[0].outcomes[1]?.odds !== null ||
            match.markets[0].outcomes[2]?.odds !== null
          );
        });
    },
    (a, b) => a.length === b.length
  );

  useEffect(() => {
    const groups = eventsToGroup(topMatchesEvents);
    setSports(groups);
  }, [topMatchesEvents]);

  useEffect(() => {
    dispatch(fetchTopMatches());
    dispatch(fetchTopOutrights());
  }, []);

  function getBetType() {
    const betTypes = [
      {
        label: t('winner'),
        id: 1
      },
      {
        label: t('overunder'),
        id: 18
      },
      {
        label: t('handicap'),
        id: 14
      },
      {
        label: t('nextGoal'),
        id: 8
      },
      {
        label: t('bs'),
        id: 29
      },
      {
        label: t('doubleChance'),
        id: 10
      }
    ];
    return (
      <div className="tip-types">
        {betTypes.map((betType) => (
          <div className="d-inline-block w-25 fw-bold " key={betType.id}>
            <button
              className={`btn btn-sm w-100 border fs-8 ${
                selectedMarketType === betType.id ? 'btn-primary fw-bold text-white' : 'btn-light'
              }`}
              onClick={() => setSelectedMarketType(betType.id)}>
              {betType.label}
            </button>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="container">
      <TitleHistoryBack title={t('start')} subTitle={t('topmatches')} />
      <Row className="">
        <Col className="tip-types-container">{getBetType()}</Col>
      </Row>
      <div className="">
        {topOutrights && topOutrights.length > 0 && (
          <div className="pb-2">
            {topOutrights.map((event) => (
              <TournamentCard key={event.se?.id} event={event} hideMoreOutcomes />
            ))}
          </div>
        )}
        {sports[0] !== undefined &&
          sports[0].length > 0 &&
          sports[0].map((leagueGroup, index) => {
            let code = null;
            if (
              leagueGroup.matches &&
              leagueGroup.matches.length > 0 &&
              leagueGroup.matches[0].categoryId
            ) {
              code = leagueGroup.matches[0].categoryId.split(':')[2];
            }
            return (
              <Fragment
                key={
                  'leaguenamesfragment' +
                  leagueGroup.category +
                  leagueGroup.league +
                  leagueGroup.matches[0].gameNumber +
                  index
                }>
                <div
                  className="text-start pb-2 fw-bold pt-1 fs-7"
                  key={
                    'leaguenames' +
                    leagueGroup.category +
                    leagueGroup.league +
                    leagueGroup.matches[0].gameNumber
                  }>
                  {code && (
                    <img
                      width="20"
                      height="13"
                      src={`${AWS_BUCKET_URL}/ClientFlags/${code}.svg`}
                      alt={code}
                      className="me-2"
                    />
                  )}
                  {leagueGroup.category + ' / ' + leagueGroup.league}
                </div>
                {leagueGroup.matches.map((match, index) => (
                  <MatchCard
                    key={match.providerId}
                    providerId={match.providerId}
                    marketType={selectedMarketType}
                    index={index}
                    sport={'0'}
                    path={location.pathname}
                    locales={locales}
                    selectedLocale={selectedLocale}
                  />
                ))}
              </Fragment>
            );
          })}
      </div>
    </div>
  );
}
